module.exports = {
  ALL: "device-all"
};
